import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { ref, computed, watch } from 'vue'

interface IProps {
  title?: string
  iconColor?: string
  icon?: string
  type?: '' | 'checkbox' | 'toggle'
  deletable?: boolean
  disable?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KMenuItem' },
  __name: 'KMenuItem',
  props: /*@__PURE__*/_mergeModels({
    title: { default: 'Menu item' },
    iconColor: { default: 'cool-gray-70' },
    icon: { default: '' },
    type: { default: '' },
    deletable: { type: Boolean, default: false },
    disable: { type: Boolean, default: false }
  }, {
    "modelValue": { type: Boolean, default: false },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['clicked', 'delete'], ["update:modelValue"]),
  setup(__props: any) {





const props = __props

const isHoveredRef = ref(false)
const isFocusedRef = ref(false)
const model = _useModel(__props, "modelValue")

const trashIconColor = computed(() => {
  if (props.disable) return 'cool-gray-50'
  else if (!props.disable && (isHoveredRef.value || isFocusedRef.value)) return 'error-100'
  else return 'error-70'
})

const localIconColor = computed(() => {
  if (props.disable) return 'cool-gray-60'
  else if (isHoveredRef.value) return 'amber-70'
  else if (props.iconColor) return props.iconColor
  return 'cool-gray-60'
})

watch(
  () => props.disable,
  () => {
    if (props.disable) model.value = false
  },
)

return (_ctx: any,_cache: any) => {
  const _component_KCheckbox = _resolveComponent("KCheckbox")!
  const _component_KToggle = _resolveComponent("KToggle")!
  const _component_KIcon = _resolveComponent("KIcon")!

  return (_openBlock(), _createElementBlock("button", {
    class: "k-menu-item text-left q-pa-xs items-center bg-white",
    disabled: __props.disable,
    onMouseover: _cache[4] || (_cache[4] = ($event: any) => (isHoveredRef.value = true)),
    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (isHoveredRef.value = false)),
    onFocus: _cache[6] || (_cache[6] = ($event: any) => (isFocusedRef.value = true)),
    onBlur: _cache[7] || (_cache[7] = ($event: any) => (isFocusedRef.value = false))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["row items-center justify-between full-width text-left q-px-12", {
        'rounded-12': (!__props.disable && isHoveredRef.value) || isFocusedRef.value,
        'bg-teal-white-10': (!__props.disable && isHoveredRef.value) || isFocusedRef.value,
      }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["row items-center q-py-12", __props.disable ? 'cool-gray-60' : 'fs-15px fw-400 cool-gray-80 text-left q-mx-xs'])
      }, [
        _renderSlot(_ctx.$slots, "prepend"),
        (__props.type === 'checkbox')
          ? (_openBlock(), _createBlock(_component_KCheckbox, {
              key: 0,
              modelValue: model.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
              disable: __props.disable
            }, null, 8, ["modelValue", "disable"]))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass({
            'text-error-100': __props.deletable && !__props.disable && (isHoveredRef.value || isFocusedRef.value),
          })
        }, _toDisplayString(__props.title), 3)
      ], 2),
      (__props.type === 'toggle')
        ? (_openBlock(), _createBlock(_component_KToggle, {
            key: 0,
            modelValue: model.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
            disable: __props.disable
          }, null, 8, ["modelValue", "disable"]))
        : _createCommentVNode("", true),
      (__props.icon)
        ? (_openBlock(), _createBlock(_component_KIcon, {
            key: 1,
            name: __props.icon,
            color: localIconColor.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('clicked')))
          }, null, 8, ["name", "color"]))
        : _createCommentVNode("", true),
      (__props.deletable)
        ? (_openBlock(), _createBlock(_component_KIcon, {
            key: 2,
            class: "cursor-pointer",
            name: "trash",
            color: trashIconColor.value,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('delete')))
          }, null, 8, ["color"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 40, _hoisted_1))
}
}

})